export default __webpack_public_path__ + "static/media/logo-konekta.34482acf.jpeg";